import script from "./CardPortraitSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardPortraitSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./CardPortraitSkeleton.vue?vue&type=style&index=0&id=0c9737ec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c9737ec"]])

export default __exports__